/* File: assets/custom-filter-sidebar.js */

(function () {
  'use strict';

  const sidebar = document.querySelector('.cfs-sidebar');
  if (!sidebar) return;

  // 1. Group open/close
  sidebar.querySelectorAll('.cfs-group-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.cfs-group').classList.toggle('open');
    });
  });

  // 2. Size tag
  sidebar.querySelectorAll('.cfs-size-tag').forEach(tag => {
    tag.addEventListener('click', function () {
      if (this.disabled) return;
      const url = this.dataset.active === 'true'
        ? this.dataset.remove : this.dataset.add;
      if (url) window.location.href = url;
    });
  });

  // 3. Category links
  sidebar.querySelectorAll('.cfs-cat-list a').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const url = this.dataset.active === 'true'
        ? this.dataset.remove : this.dataset.add;
      if (url) window.location.href = url;
      else window.location.href = this.href;
    });
  });

  // 4. Price range slider
  const track  = document.getElementById('cfs-track');
  const fill   = document.getElementById('cfs-fill');
  const thumbL = document.getElementById('cfs-tl');
  const thumbR = document.getElementById('cfs-tr');
  const iMin   = document.getElementById('cfs-imin');
  const iMax   = document.getElementById('cfs-imax');
  const pMin   = document.getElementById('cfs-pmin');
  const pMax   = document.getElementById('cfs-pmax');

  if (track && thumbL && thumbR && iMin && iMax) {
    const RANGE_MAX = parseFloat(iMin.dataset.max) || 100000;
    let minVal = parseFloat(iMin.value) || 0;
    let maxVal = parseFloat(iMax.value) || RANGE_MAX;

    function money(cents) {
      return '$' + Math.round(cents / 100);
    }
    function update() {
      const lp = (minVal / RANGE_MAX) * 100;
      const rp = (maxVal / RANGE_MAX) * 100;
      thumbL.style.left = lp + '%';
      thumbR.style.left = rp + '%';
      fill.style.left   = lp + '%';
      fill.style.right  = (100 - rp) + '%';
      if (pMin) pMin.textContent = money(minVal);
      if (pMax) pMax.textContent = money(maxVal);
      iMin.value = minVal;
      iMax.value = maxVal;
    }
    function drag(thumb, isLeft) {
      function move(e) {
        const r = track.getBoundingClientRect();
        const cx = e.touches ? e.touches[0].clientX : e.clientX;
        const pct = Math.max(0, Math.min(1, (cx - r.left) / r.width));
        const val = Math.round(pct * RANGE_MAX);
        if (isLeft) minVal = Math.min(val, maxVal - 100);
        else        maxVal = Math.max(val, minVal + 100);
        update();
      }
      function stop() {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', stop);
        document.removeEventListener('touchmove', move);
        document.removeEventListener('touchend', stop);
      }
      thumb.addEventListener('mousedown', e => {
        e.preventDefault();
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', stop);
      });
      thumb.addEventListener('touchstart', () => {
        document.addEventListener('touchmove', move, { passive: true });
        document.addEventListener('touchend', stop);
      }, { passive: true });
    }
    drag(thumbL, true);
    drag(thumbR, false);
    update();
  }

  // 5. Clear All
  const clearBtn = sidebar.querySelector('.cfs-clear-btn');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      window.location.href = window.location.pathname;
    });
  }

  // 6. Apply button
  const applyBtn = document.getElementById('cfs-apply');
  if (applyBtn) {
    applyBtn.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      if (iMin && iMax) {
        if (iMin.name) params.set(iMin.name, iMin.value);
        if (iMax.name) params.set(iMax.name, iMax.value);
      }
      params.delete('filter.p.m.reviews.rating');
      sidebar.querySelectorAll('.cfs-rcb:checked').forEach(cb => {
        params.append('filter.p.m.reviews.rating', cb.value);
      });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

})();